import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, Row, Table, Tabs } from 'antd';
import { queryProjectList } from '@api/protect';

const FormItem = Form.Item;
const { TabPane } = Tabs;

export default hocParams => {
  class HocIndex extends Component {
    constructor(props) {
      super(props);
      this.state = {
        data: [],
        isLoading: false,
        status: 0,
        total: 0,
        pageNo: 1,
      };
    }

    componentDidMount() {
      this.model = this.props.params.model;
      this.loadData(this.props.params.model, 1);
    }

    componentWillReceiveProps(nextProps) {
      if (this.props.params.model !== nextProps.params.model) {
        this.model = nextProps.params.model;
        this.loadData(nextProps.params.model, 1);
      }
    }

    // 加载需公司回单卡信息数据
    loadData = (model, pageNo) => {
      const params = {};
      const { condition, status } = this.state;

      const no = this.state.pageNo;
      const current = pageNo || no;

      params.limit = 15;
      params.start = current;
      params.condition = condition || '';
      params.model = model;
      params.status = status;

      this.setState({
        pageNo: current,
        isLoading: true,
      });
      queryProjectList(params).then(res => {
        if (res.statusCode === 200) {
          this.setState({
            data: res.data,
            total: res.totalSize,
            isLoading: false,
          });
        }
      });
    };

    handleSubmit = e => {
      e.preventDefault();
      const { pageNo } = this.state;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          this.setState(
            {
              condition: values.condition,
            },
            () => {
              this.loadData(pageNo);
            },
          );
        }
      });
    };

    renderSearchForm = () => {
      const {
        form: { getFieldDecorator },
      } = this.props;
      const { condition } = this.state;
      return (
        <div>
          <Form layout="inline" onSubmit={this.handleSubmit} style={{ textAlign: 'right' }}>
            <FormItem>
              {getFieldDecorator('condition', {
                initialValue: condition || null,
              })(<Input placeholder="请输入关键字" />)}
            </FormItem>
            <FormItem>
              <Button htmlType="submit">查询</Button>
            </FormItem>
          </Form>
        </div>
      );
    };

    renderTable = () => {
      const { data, isLoading, total, pageNo } = this.state;
      const { columns } = hocParams;

      const pagination = {
        showSizeChanger: false,
        pageSize: 15,
        total,
        current: pageNo,
        onChange: current => {
          this.loadData(current);
        },
        showTotal: showTotal => {
          return `共 ${showTotal} 条`;
        },
      };

      return (
        <Table
          rowKey="uuid"
          loading={isLoading}
          columns={columns(this.model)}
          dataSource={data}
          pagination={pagination}
        />
      );
    };

    callback = (model, status) => {
      this.setState({ status }, () => this.loadData(model, 1));
    };

    render() {
      return (
        <Card>
          <div className="tableList">
            <Row style={{ paddingBottom: '20px' }}>
              <Col span={24}>
                <div className="tableListForm">{this.renderSearchForm()}</div>
              </Col>
            </Row>
          </div>
          <Tabs defaultActiveKey="0" onChange={key => this.callback(this.model, key)}>
            <TabPane tab="待处理" key="0">
              {this.renderTable()}
            </TabPane>
            <TabPane tab="已同意" key="1">
              {this.renderTable()}
            </TabPane>
            <TabPane tab="已拒绝" key="2">
              {this.renderTable()}
            </TabPane>
            <TabPane tab="全部" key="-1">
              {this.renderTable()}
            </TabPane>
          </Tabs>
        </Card>
      );
    }
  }

  return Form.create()(HocIndex);
};



// WEBPACK FOOTER //
// ./src/components/project/HocIndex.js